import CloseIcon from '@mui/icons-material/Close'
import { Box, Button, IconButton, Modal, Typography } from '@mui/material'
import React, { useState } from 'react'
import SearchBar from '../CreateTrip/SearchBar.js'

import { useStates } from '../../../../StateProvider.js'
// import { useViewPort } from '../../../../ViewportProvider.js'
import '../../../../scss/gps.scss'
import { useEmulatorStore } from '../../../../stores/emulator/store.tsx'

const MovePositionDialog = () => {
  const selectedEmulator = useEmulatorStore((state) => state.selectedEmulator)
  const moveEmulator = useEmulatorStore((state) => state.moveEmulator)

  const [fromLat, setFromLat] = useState()
  const [fromLong, setFromLong] = useState()
  const [inputValue, setInputValue] = useState('')
  const [error, setError] = useState('')

  const { isMoveDialogVisible, setIsMoveDialogVisible, showToast } = useStates()
  // const { width } = useViewPort()
  // const breakpoint = 620
  // const isMobile = width < breakpoint

  const handleClose = () => {
    setIsMoveDialogVisible(false)
  }

  const handleInputChange = (event) => {
    setInputValue(event.target.value)
  }

  const handleAddClick = () => {
    if (!fromLat && !fromLong) {
      showToast('Please fill Location you want to move to!', 'error')
      return
    }

    setError('')

    moveEmulator({
      emulator: selectedEmulator,
      latitude: fromLat,
      longitude: fromLong,
      moveMarker: true
    })

    handleClose()
  }

  return (
    <>
      <div className="gps_createTrip_overlay">
        <Modal
          open={isMoveDialogVisible}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box className="gps-set-position-box">
            {/* Close Button */}
            <IconButton
              edge="end"
              onClick={handleClose}
              aria-label="close"
              className="icon-btn"
            >
              <CloseIcon />
            </IconButton>

            {/* Header */}
            <Typography
              variant="h6"
              component="h2"
              className="set-position-header"
            >
              Set Position
            </Typography>

            {/* Input Field */}
            <div className="parent-search-bar">
              <label className="label-of-set-position">
                Address to move to<span className="text-danger">*</span>
              </label>
              <SearchBar
                setLat={setFromLat}
                setLong={setFromLong}
                inputValue={inputValue}
                setInputValue={setInputValue}
                handleInputChange={handleInputChange}
                label="Address to move to"
                className="set-position-text-field"
              />
            </div>

            {/* Submit Button */}
            <Button
              onClick={handleAddClick}
              className="custom-font set-position-btn"
            >
              Show on map
            </Button>

            {error && (
              <p
                className="error"
                style={{ color: 'red', fontFamily: 'Poppins, sans-serif' }}
              >
                {error}
              </p>
            )}
          </Box>
        </Modal>
      </div>
    </>
  )
}

export default MovePositionDialog
